import React, { useState } from 'react';
import { useAuth } from '../App';
import { Button } from './ui/button';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const CSVExportButton = ({ entityType, entityLabel, buttonVariant = "outline", buttonSize = "default" }) => {
  const { api } = useAuth();
  const [exporting, setExporting] = useState(false);

  const getExportEndpoint = () => {
    const masterDataTypes = ['university', 'program', 'country', 'city', 'intake', 'document_type'];
    if (masterDataTypes.includes(entityType)) {
      return `/csv/export/master-data/${entityType}`;
    }
    return `/csv/export/${entityType}`;
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      const response = await api().get(getExportEndpoint(), { responseType: 'blob' });
      
      // Get filename from Content-Disposition header or generate one
      const contentDisposition = response.headers['content-disposition'];
      let filename = `${entityType}_export.csv`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename=(.+)/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success(`${entityLabel} exported successfully`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Export failed');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button 
      variant={buttonVariant} 
      size={buttonSize} 
      onClick={handleExport} 
      disabled={exporting}
      data-testid={`export-${entityType}-btn`}
    >
      {exporting ? (
        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
      ) : (
        <Download className="w-4 h-4 mr-2" />
      )}
      Export CSV
    </Button>
  );
};

export default CSVExportButton;
